// pages/monthly/monthlychecklist.update.jsx
// 📍 Complete with locationId

import { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux"; // ✅ ADD
import {
  Input,
  Button,
  List,
  Spin,
  Card,
  Switch,
  Flex,
  Checkbox,
  Slider,
  message,
} from "antd";
import {
  useUpdateChecklistMutation,
  useFetchChecklistQuery,
} from "../opencheck/checklists.service";
import { EditOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { quillFormats, quillModules } from "../../constant";
import ReactQuill from "react-quill";
import "./style.css";

const MonthlycheckUpdate = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const navigate = useNavigate();
  const { id } = useParams();
  const user = useSelector((state) => state.app.user); // ✅ ADD

  // ✅ Get locationId
  const locationId = user?.activeLocationId || user?.restaurantId;

  console.log("🔍 Update Page - ID:", id);
  console.log("🔍 Update Page - Location ID:", locationId);

  const [newChecklist, setNewChecklist] = useState("");
  const [isInput, setIsInput] = useState(false);
  const [record, setRecord] = useState(false);
  const [isSection, setIsSection] = useState(false);
  const [isTempSlider, setIsTempSlider] = useState(false);
  const [tempSlider, setTempSlider] = useState(0);
  const [isCompleted, setIsCompleted] = useState(false);
  const [checkContent, setCheckContent] = useState("");
  const [charCount, setCharCount] = useState(0);
  const quillRef = useRef(null);
  const CHARACTER_LIMIT = 1500;

  // ✅ Fetch with id and locationId
  const {
    data = { data: { checklist: {} } },
    isFetching,
    isSuccess,
  } = useFetchChecklistQuery(
    { id, locationId }, // ✅ CHANGE
    { refetchOnMountOrArgChange: true, skip: !id }
  );

  const {
    data: { checklist },
  } = data;

  const [updateChecklist, { isLoading: isEditLoading }] =
    useUpdateChecklistMutation();

  useEffect(() => {
    if (isSuccess && checklist) {
      setNewChecklist(
        checklist["title"]?.[language] || checklist["title"]?.["default"] || ""
      );
      setIsInput(checklist.isInput || false);
      setIsCompleted(checklist.status === "completed");
      setIsTempSlider(checklist.isTempSlider || false);
      setTempSlider(checklist.tempSlider || 0);
      setRecord(checklist.isDateRecord || false);
      setCheckContent(
        checklist["content"]?.[language] || checklist["content"]?.["default"] || ""
      );
      setIsSection(checklist.isSection || false);
    }
  }, [checklist, isSuccess, language]);

  // ✅ Update with locationId
  const handleUpdate = async () => {
    try {
      console.log("🔄 Updating checklist:", {
        id,
        locationId,
        data: {
          isDateRecord: record,
          isInput,
          isSection,
          isTempSlider,
          tempSlider,
          title: newChecklist,
          status: isCompleted ? "completed" : "pending",
          content: isInput && checkContent ? checkContent : "",
        },
      });

      await updateChecklist({
        id,
        data: {
          isDateRecord: record,
          isInput,
          isSection,
          isTempSlider,
          tempSlider,
          title: newChecklist,
          status: isCompleted ? "completed" : "pending",
          content: isInput && checkContent ? checkContent : "",
        },
        locationId: locationId, // ✅ ADD
      }).unwrap();

      message.success("Checklist updated successfully!");
      navigate("/monthlychecks");
    } catch (err) {
      console.log("❌ Failed to update checklist:", err);
      message.error("Failed to update checklist");
    }
  };

  const handleChange = (html, delta, source, editor) => {
    const text = editor.getText();
    const textLength = text.trim().length;

    if (textLength <= CHARACTER_LIMIT) {
      setNewChecklist(html);
      setCharCount(textLength);
    } else {
      if (quillRef.current) {
        const quill = quillRef.current.getEditor();
        quill.root.innerHTML = newChecklist;
      }
    }
  };

  return (
    <Spin spinning={isFetching}>
      <Card
        title={t("MONTHLYCHECK EDIT")}
        style={{ fontSize: "20px" }}
        bordered={false}
        className="opencheck-create-page"
        extra={
          <Flex justify="center">
            <Button type="default" onClick={() => navigate("/monthlychecks")}>
              {t("BACK")}
            </Button>
          </Flex>
        }
      >
        <div className="opencheck-create-page-container">
          <ReactQuill
            ref={quillRef}
            theme="snow"
            value={newChecklist}
            onChange={handleChange}
            modules={quillModules}
            formats={quillFormats}
          />
          <div style={{ textAlign: "right", fontSize: "14px" }}>
            {charCount} / 1500
          </div>

          <div className="opencheck-create-page-container-switch">
            <h4>{t("ADD TEXTBOX")}</h4>
            <Switch
              checked={isInput}
              onChange={(e) => {
                if (e) setIsSection(false);
                setIsInput(e);
              }}
            />
          </div>

          <div className="opencheck-create-page-container-switch">
            <h4>{t("RECORD TIME & DATE")}</h4>
            <Switch
              checked={record}
              onChange={(e) => {
                if (e) setIsSection(false);
                setRecord(e);
              }}
            />
          </div>

          <div className="opencheck-create-page-container-switch">
            <h4>{t("ADD TEMPERATURE SLIDER")}</h4>
            <Switch
              checked={isTempSlider}
              onChange={(e) => {
                if (e) setIsSection(false);
                setIsTempSlider(e);
              }}
            />
          </div>

          <div className="opencheck-create-page-container-switch">
            <h4>{t("SECTION")}</h4>
            <Switch
              checked={isSection}
              onChange={(e) => {
                if (e) {
                  setIsInput(false);
                  setRecord(false);
                  setIsTempSlider(false);
                  setTempSlider(0);
                }
                setIsSection(e);
              }}
            />
          </div>

          <div className="opencheck-create-page-container-button">
            <Button
              color="green"
              variant="solid"
              icon={<EditOutlined />}
              size="small"
              onClick={handleUpdate}
              loading={isEditLoading}
            >
              {t("Update")}
            </Button>
          </div>
        </div>

        <List
          className="opencheck-create-page-insight"
          itemLayout="horizontal"
          dataSource={[
            {
              isSection: isSection,
              title: isSection ? "" : newChecklist,
              description: isSection ? (
                <div
                  className="compliance-checklist-content"
                  dangerouslySetInnerHTML={{
                    __html: newChecklist,
                  }}
                />
              ) : (
                <div className="opening-check-add-task">
                  {isInput && (
                    <div style={{ padding: "5px 15px" }}>
                      <Input
                        style={{ background: "transparent" }}
                        value={checkContent}
                        onChange={(e) => setCheckContent(e.target.value)}
                      />
                    </div>
                  )}
                  {isTempSlider && (
                    <>
                      <div
                        style={{
                          fontSize: "1.5rem",
                          textAlign: "center",
                          marginTop: 10,
                          fontWeight: "bold",
                        }}
                      >
                        {tempSlider.toFixed(1)}°C
                      </div>
                      <Slider
                        styles={{
                          track: { background: "transparent" },
                          tracks: { background: "rgb(109, 179, 63)" },
                        }}
                        min={-30}
                        max={120}
                        step={0.1}
                        onChange={(temp) => setTempSlider(temp)}
                        value={tempSlider}
                      />
                    </>
                  )}
                  {record && <div>*RECORD TIME AND DATE AUTOMATICALLY*</div>}
                </div>
              ),
            },
          ]}
          renderItem={(checklist, index) => (
            <List.Item
              className={
                checklist.isSection ? "background-section" : "background-task"
              }
              actions={[
                <Checkbox
                  checked={isCompleted}
                  onChange={(e) => setIsCompleted(e.target.checked)}
                />,
              ]}
            >
              <List.Item.Meta
                title={
                  checklist.title !== "" && (
                    <div
                      className="compliance-checklist-content"
                      dangerouslySetInnerHTML={{ __html: checklist.title }}
                    />
                  )
                }
                description={checklist.description}
              />
            </List.Item>
          )}
        />
      </Card>
    </Spin>
  );
};

export default MonthlycheckUpdate;